<script setup>
import { computed } from 'vue';
import { format } from 'date-fns';
import { useI18n } from 'vue-i18n';
import Avatar from 'next/avatar/Avatar.vue';

const props = defineProps({
  createdBy: { type: Object, default: null },
  updatedBy: { type: Object, default: null },
  updatedAt: { type: String, default: null },
});

const { t } = useI18n();

const createdByName = computed(
  () => props.createdBy?.available_name ?? props.createdBy?.email ?? ''
);

const editedByLine = computed(() => {
  if (!props.updatedBy) return '';
  const name = props.updatedBy.available_name ?? props.updatedBy.email ?? '';
  const date = props.updatedAt
    ? format(new Date(props.updatedAt), 'MMM d, yyyy')
    : '';
  return `${t('CANNED_MGMT.LIST.AUTHOR.EDITED_BY')} ${name} · ${date}`;
});
</script>

<template>
  <div v-if="createdBy" class="flex flex-col gap-1">
    <div class="flex items-center gap-2">
      <Avatar :name="createdByName" :size="24" rounded-full />
      <span class="font-medium text-n-slate-12">{{ createdByName }}</span>
    </div>
    <span v-if="updatedBy" class="text-xs text-n-slate-11">{{
      editedByLine
    }}</span>
  </div>
  <div v-else class="text-n-slate-11">--</div>
</template>
